/** @jsx jsx */
import { jsx, Grid } from 'theme-ui';
export default props => <Grid columns={[1, 1, 1, 1, 3]} children={props.children} />;
